<template>
  <div class="research_group_container" style="background: #fafafa">
    <!-- <base-header :headerName="headerName" @goBack="goBack" /> -->
    <div class="page-progress flex-col">
      <div class="main1 flex-col">
        <div class="group_progress flex-col" :style="!showaberrationType ? {height: '118px'}: {}">
          <div class="layer3 flex-col">
            <div class="main3 flex-row justify-between">
              <span class="info1">订单编号：{{ SCProgressInfo.orderNo }}</span>
              <button
                class="block1 flex-col"
                id="tag-copy"
                :data-clipboard-text="SCProgressInfo.orderNo"
                @click="handleCopy"
              >
                <span class="info2">复制</span>
              </button>
            </div>
            <div class="main4 flex-col"></div>
            <div class="main5 flex-row">
              <div class="outer1 flex-col">
                <img
                  class="icon3"
                  referrerpolicy="no-referrer"
                  src="/static/img/service_product.png"
                />
              </div>
              <span class="info3">{{ SCProgressInfo.solutionName }}</span>
            </div>
            <div class="main6 flex-row justify-between" v-show="showaberrationType">
              <img
                class="label2"
                referrerpolicy="no-referrer"
                src="/static/img/注意.svg"
              />
              <span class="word2">{{
                getaberration(SCProgressInfo.aberrationType)
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="group3 flex-col"
          v-for="(
            contractProgressInfo, index
          ) in SCProgressInfo.contractProgressInfoList"
          :key="index"
        >
          <contract-progress-info
            :contractProgressInfo="contractProgressInfo"
            :aberrationType="SCProgressInfo.aberrationType"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { mapGetters } from 'vuex'
import EMKT from '../../../emkt.js'
// import {SFprogressInfos} from './data.js'
import ContractProgressInfo from '@/views/serviceProgressRefactor/serviceProgress/ContractProgressInfo.vue'
// import BaseHeader from '@/views_v_2.6/components/BaseHeader.vue'
export default {
  data () {
    return {
      headerName: '进展详情',
      SCProgressInfo: null
    }
  },
  components: {
    ContractProgressInfo
    // BaseHeader
  },
  created () {
    let progressInfos = this.$route.query.SCProgressInfo
    if (progressInfos) {
      progressInfos = JSON.parse(progressInfos)
      this.SCProgressInfo = {
        ...progressInfos,
        contractProgressInfoList: progressInfos.contractProgressInfoList.map(
          (contractProgressInfo) => ({
            ...contractProgressInfo,
            show: true,
            experimentModules: contractProgressInfo.experimentModules.map(
              (experiment) => {
                const { isException, completedPercent } =
                  this.getExperimentOtherInfo(experiment.taskModules)
                return { ...experiment, isException, completedPercent }
              }
            )
          })
        )
      }
    }
  },
  computed: {
    ...mapGetters(['isWapp']),
    showaberrationType () {
      return this.SCProgressInfo.aberrationType
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    getaberration (aberrationType) {
      return !aberrationType
        ? ''
        : EMKT.ADBERRATION_MESSAGE[aberrationType]
    },
    handleCopy () {
      const clipboard = new Clipboard('#tag-copy')
      clipboard.on('success', () => {
        this.$weui.toast('复制成功', 1500)
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', () => {
        this.$weui.topTips('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    getExperimentOtherInfo (taskModules) {
      let isException = false
      let completedTasks = []
      taskModules.forEach((task) => {
        if (task.publishComments.length > 0) {
          isException = true
        }
        if (
          task.currentStatus === EMKT.EXPERIMENT_MODULES_STATUS_ENDING ||
          task.currentStatus === EMKT.EXPERIMENT_MODULES_STATUS_NAME__END_STOP
        ) {
          completedTasks.push(task)
        }
      })
      const completedPercent =
        taskModules.length > 0
          ? ((completedTasks.length / taskModules.length) * 100).toFixed(0)
          : 0
      return { isException, completedPercent }
    }
  }
}
</script>
<style scoped>
  .page-progress {
    position: relative;
    overflow: hidden;
    width: 100vw;
    top:1vw;
      /* top: 14.93vw; */
    bottom: 4vw;
  }

  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
    background: #FAFAFA;
  }

  .main1 {
    margin-bottom: 10px;
  }


  .group2 {
    height: 138px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    margin: 10px 10px 0 10px;
  }
  .group_progress{
    height: 138px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    margin: 10px 10px 0 10px;
  }
  .hd {
    display: flex;
    flex-shrink: 0;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }

  .layer3 {
    height: 118px;
    margin-top: 10px;
  }

  .main3 {
    height: 23px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .info1 {
    width: 116px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-top: 3px;
  }

  .block1 {
    height: 23px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(151, 151, 151, 1);
    width: 42px;
  }

  .info2 {
    width: 42px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: center;
    margin-top: 3px;
  }

  .main4 {
    height: 1px;
    background: url(/static/img/SketchPng6799fd0a248a71aa1c89dfa7306d422c500ce1cdb8d468ad498d14b34892f939.png)
    100% no-repeat;
    margin-top: 6px;
  }

  .main5 {
    height: 47px;
    margin: 14px 0 0 15px;
  }

  .outer1 {
    z-index: 69;
    position: relative;
    width: 47px;
    height: 47px;
    border-radius: 12px;
    overflow: hidden;
    background: url(/static/img/SketchPng313d8023457f21e77dbe6b6bcce9f9e5eb8d92658e02ea1d65d14230abceca95.png)
    100% no-repeat;
  }

  .icon3 {
    z-index: 70;
    position: absolute;
    left: 3px;
    top: 3px;
    width: 42px;
    height: 40px;
  }

  .info3 {
    margin: 0 15px;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    margin-top: 5px;
    text-overflow: ellipsis;
    word-wrap: normal
  }

  .main6 {
    width: 306px;
    height: 17px;
    margin: 10px 0 0 15px;
  }

  .label2 {
    width: 13px;
    height: 13px;
    margin-top: 2px;
  }

  .word2 {
    width: 288px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(254, 101, 77, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
  }

  .group3 {
    z-index: 2;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    margin: 10px 10px 0 10px;
  }


</style>






// WEBPACK FOOTER //
// index.vue?6bb1a5a4